import { useStyles } from './index.style';

const GlobalStyles = () => {
  useStyles();

  return null;
};

export default GlobalStyles;
